import { EMPLOYEE } from "./types";

import ActionHelper from "../helpers/ActionHelper";
import moment, { isMoment } from "moment";

export const createEmployee = (form) => (dispatch) => {
  let payload = form;

  if (moment.isMoment(payload.birthday))
    payload.birthday = moment(payload.birthday).format("YYYY-MM-DD");

  return ActionHelper.requestServer(
    "POST",
    "/employee",
    payload,
    EMPLOYEE.EMPLOYEE_CREATE_REQUEST,
    EMPLOYEE.EMPLOYEE_CREATE_SUCCESS,
    EMPLOYEE.EMPLOYEE_CREATE_FAIL,
    dispatch,
  );
};

export const getEmployees = (filters) => (dispatch) => {
  if (filters)
    filters = Object.keys(filters)
      .map((key) => key + "=" + filters[key])
      .join("&");

  return ActionHelper.requestServer(
    "GET",
    `/employee?${filters}`,
    null,
    EMPLOYEE.EMPLOYEE_GET_EMPLOYEES_REQUEST,
    EMPLOYEE.EMPLOYEE_GET_EMPLOYEES_SUCCESS,
    EMPLOYEE.EMPLOYEE_GET_EMPLOYEES_FAIL,
    dispatch,
  );
};

export const getEmployee = (id) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    "/employee/" + id,
    null,
    EMPLOYEE.EMPLOYEE_GET_REQUEST,
    EMPLOYEE.EMPLOYEE_GET_SUCCESS,
    EMPLOYEE.EMPLOYEE_GET_FAIL,
    dispatch,
  );
};

export const updateEmployee = (email, form) => (dispatch) => {
  let payload = form;

  if (moment.isMoment(payload.birthday))
    payload.birthday = moment(payload.birthday).format("YYYY-MM-DD");

  return ActionHelper.requestServer(
    "PUT",
    "/employee/" + email,
    payload,
    EMPLOYEE.EMPLOYEE_UPDATE_REQUEST,
    EMPLOYEE.EMPLOYEE_UPDATE_SUCCESS,
    EMPLOYEE.EMPLOYEE_UPDATE_FAIL,
    dispatch,
  );
};

export const deleteEmployee = (email) => (dispatch) => {
  return ActionHelper.requestServer(
    "DELETE",
    "/employee/" + email,
    null,
    EMPLOYEE.EMPLOYEE_DELETE_REQUEST,
    EMPLOYEE.EMPLOYEE_DELETE_SUCCESS,
    EMPLOYEE.EMPLOYEE_DELETE_FAIL,
    dispatch,
  );
};

export const checkEmployeeExists = (form) => (dispatch) => {
  return ActionHelper.requestServer(
    "POST",
    "/employee/exists",
    form,
    EMPLOYEE.EMPLOYEE_CHECK_EXISTENCE_REQUEST,
    EMPLOYEE.EMPLOYEE_CHECK_EXISTENCE_SUCCESS,
    EMPLOYEE.EMPLOYEE_CHECK_EXISTENCE_FAIL,
    dispatch,
  );
};

export const getCompaniesOfEmployee =
  (employee, isSeniorEmployee) => (dispatch) => {
    return ActionHelper.requestServer(
      "GET",
      "/employee/" +
        employee +
        "/company?isSeniorEmployee=" +
        !!isSeniorEmployee,
      null,
      EMPLOYEE.EMPLOYEE_GET_COMPANIES_REQUEST,
      EMPLOYEE.EMPLOYEE_GET_COMPANIES_SUCCESS,
      EMPLOYEE.EMPLOYEE_GET_COMPANIES_FAIL,
      dispatch,
    );
  };

export const getSchedule = (employeeEmail) => (dispatch) => {
  return ActionHelper.requestServer(
    "GET",
    `/employee/${employeeEmail}/schedule`,
    null,
    EMPLOYEE.EMPLOYEE_GET_SCHEDULE_REQUEST,
    EMPLOYEE.EMPLOYEE_GET_SCHEDULE_SUCCESS,
    EMPLOYEE.EMPLOYEE_GET_SCHEDULE_FAIL,
    dispatch,
  );
};

export const getHourRegistrationOfEmployee = (
  employeeEmail,
  beginDate,
  endDate,
) => {
  let params = [];

  if (isMoment(beginDate)) {
    beginDate.startOf("day");

    params.push(`beginDate=${beginDate.toISOString()}`);
  }

  if (isMoment(endDate)) {
    endDate.endOf("day");

    params.push(`endDate=${endDate.toISOString()}`);
  }

  return ActionHelper.requestServer(
    "GET",
    `/employee/${employeeEmail}/hour_registration?${params.join("&")}`,
  );
};

export const getEmployeeShift = (employeeEmail, shiftId) =>
  ActionHelper.requestServer(
    "GET",
    `/employee/${employeeEmail}/shift/${shiftId}`,
  );

export const activateEmployee = (employeeEmail) => (dispatch) => {
  return ActionHelper.requestServer(
    "PATCH",
    `/employee/${employeeEmail}/activate`,
    null,
    EMPLOYEE.EMPLOYEE_ACTIVATE_REQUEST,
    EMPLOYEE.EMPLOYEE_ACTIVATE_SUCCESS,
    EMPLOYEE.EMPLOYEE_ACTIVATE_FAIL,
    dispatch,
  );
};

export const deactivateEmployee = (employeeEmail) => (dispatch) => {
  return ActionHelper.requestServer(
    "PATCH",
    `/employee/${employeeEmail}/deactivate`,
    null,
    EMPLOYEE.EMPLOYEE_DEACTIVATE_REQUEST,
    EMPLOYEE.EMPLOYEE_DEACTIVATE_SUCCESS,
    EMPLOYEE.EMPLOYEE_DEACTIVATE_FAIL,
    dispatch,
  );
};



// WEBPACK FOOTER //
// ./src/actions/employeeActions.js